import React from 'react';
import { render } from 'react-dom';
import './css/style.css';
import Router from './components/Router';

var destination = document.getElementById('main');

render(<Router />, destination);



// WEBPACK FOOTER //
// ./src/index.js